import React from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../utils/cn';

interface DashboardCardProps {
  title: string;
  value: string;
  change?: {
    value: string;
    type: 'positive' | 'negative';
  };
  description: string;
  progress: number;
  icon: React.ComponentType<{ className?: string }>;
  link: string;
}

export function DashboardCard({
  title,
  value,
  change,
  description,
  progress,
  icon: Icon,
  link,
}: DashboardCardProps) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(link)}
      className="relative cursor-pointer overflow-hidden rounded-lg bg-white px-4 py-5 shadow-sm transition-shadow hover:shadow-md sm:px-6"
    >
      <dt>
        <div className="absolute rounded-md bg-purple-500 p-3">
          <Icon className="h-6 w-6 text-white" />
        </div>
        <p className="ml-16 truncate text-sm font-medium text-gray-500">{title}</p>
      </dt>
      <dd className="ml-16">
        <p className="text-2xl font-semibold text-gray-900">{value}</p>
        {change && (
          <div className="flex items-baseline">
            <p
              className={cn(
                'text-sm font-semibold',
                change.type === 'positive' ? 'text-green-600' : 'text-red-600'
              )}
            >
              {change.value}
            </p>
            <p className="ml-2 text-sm text-gray-500">{description}</p>
          </div>
        )}
        <div className="mt-2">
          <div className="h-2 w-full rounded-full bg-gray-200">
            <div
              className="h-2 rounded-full bg-purple-600"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </dd>
    </div>
  );
}